<template>
  <div class="mb-2 -mt-44 w-full bg-primary md:-mb-6 md:-mt-32" id="sectionC">
    <div class="text-primary">
      <div class="flex flex-col justify-between items-center">
        <div class="flex relative flex-col justify-center items-center w-full md:ml-8">
          <div class="absolute space-x-2 opacity-25 text-primary text-icon_muted">
            <i class="text-9xl fas fa-angle-left"></i>
            <i class="text-8xl transform rotate-90 fas fa-slash"></i>
            <i class="text-9xl fas fa-angle-right"></i>
          </div>
          <div class="flex justify-center items-center pb-8 uppercase text-primary"><h3
            class="absolute top-0 text-2xl font-bold tracking-wide lg:text-3xl">Contact</h3></div>
        </div>
        <div class="flex flex-wrap justify-between items-center mt-16 w-full md:mt-12 lg:ml-10">
          <div class="flex-col justify-between items-stretch space-y-6 w-full h-full md:w-1/3 md:space-y-12">
            <div class="-mt-8 w-full md:mt-0">
              <p class="justify-between items-center font-bold tracking-tight text-justify opacity-80 lg:text-xl">I am available to
                work with you, contact me and let's build awesome things together</p>
            </div>
            <div
              class="w-full flex flex-col justify-between h-32 md:h-full items-center border-l-3.5 border-secondary bg-secondary pb-7 pt-1 space-y-3">
              <a href="mailto:gabrielilochi@gmail.com?subject=Are You Open To A Role" class="select-none no-highlight"><span><i class="text-2xl fas fa-envelope text-secondary lg:text-3xl no-highlight"></i></span></a>
              <a href="mailto:gabrielilochi@gmail.com?subject=Are You Open To A Role" class="select-none no-highlight"><span class="text-xl tracking-tight select-none lg:text-2xl no-highlight">gabrielilochi@gmail.com</span></a>
            </div>
            <div
              class="w-full flex flex-col  h-32 md:h-full justify-between items-center border-l-3.5 border-secondary bg-secondary pb-7 pt-1 space-y-3">
              <a href="tel:+2348166195490" class="select-none no-highlight"><span><i class="text-2xl transform fas fa-phone-volume text-secondary lg:text-3xl skew-x-30 no-highlight"></i></span></a>
              <a href="tel:+2348166195490" class="select-none no-highlight"><span class="text-xl tracking-tight select-none lg:text-2xl no-highlight">+2348166195490</span></a>
            </div>
          </div>
          <div class="pl-2 mt-14 w-full md:w-2/3 md:pl-8 md:mt-0">
            <form @submit.prevent="sendEmail"
                  class="space-y-4 text-xl tracking-wide md:pl-6 lg:pl-16 md:pr-6">
              <div class="flex flex-col w-full">
                <div class="mb-2 text-justify" v-if="response.success"><span :class="response.success ? 'text-success' : ''"
                                                                        class="px-1 text-justify overflow-ellipsis">{{
                    response.success
                  }}</span></div>
                <div class="mb-2 text-justify" v-if="response.error"><span :class="response.error ? 'text-danger' : ''"
                                                                      class="px-1 text-justify overflow-ellipsis">{{
                    response.error
                  }}</span></div>
              </div>
              <div class="flex justify-between items-center space-x-4 w-full">
                <div class="w-1/2">
                  <label for="name" class="flex flex-col"><span class="font-bold opacity-60">Name</span>
                    <input type="text" required v-model="contact.sender_name" id="name" class="bg-primary
                    pt-2 border-b-2 border-secondary opacity-50 focus:outline-none">
                    <span class="text-danger" v-if="sender_name_invalid"> {{ errors.sender_name }}</span>
                  </label>
                </div>
                <div class="pr-4 w-1/2 md:pr-0">
                  <label for="email" class="flex flex-col"> <span class="font-bold opacity-60">Email</span>
                    <input type="email" v-model="contact.sender_email" id="email" required
                           class="clear-left pt-2 border-b-2 opacity-50 bg-primary border-secondary focus:outline-none">
                    <span class="text-danger" v-if="sender_email_invalid"> {{ errors.sender_email }}</span>
                  </label>
                </div>
              </div>
              <div class="pt-4 w-full md:pt-8">
                <label for="message" class="flex flex-col"><span class="font-bold opacity-60">Message</span>
                  <textarea required v-model="contact.sender_message" id="message" cols="30" rows="5"
                            class="clear-left pt-2 border-b-2 opacity-50 resize-y bg-primary border-secondary focus:outline-none"></textarea>
                  <span class="text-danger" v-if="sender_message_invalid"> {{ errors.sender_message }}</span>
                </label>
              </div>
              <div class="pt-6 w-full md:pt-2">
                <button type="submit"
                        class="w-full md:w-auto py-3.5 px-7 border-1 border-secondary text-sm font-bold rounded-lg
                        focus:outline-none focus:text-secondary ring-1 ring-secondary uppercase bg-btn hover:text-secondary opacity-60">
                  Send Message &nbsp; <i class="text-xl fas fa-spinner fa-spin text-success" v-if="sendMailLoading"></i></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailJs from 'emailjs-com'

export default {
  name: 'Contact',
  data () {
    return {
      contact: {
        sender_name: '',
        sender_email: '',
        sender_message: ''
      },
      response: {
        success: '',
        error: ''
      },
      errors: {
        sender_name: '',
        sender_email: '',
        sender_message: ''
      },
      sendMailLoading: false
    }
  },
  methods: {
    sendEmail () {
      this.resetErrors()
      if (this.contact.sender_name.length < 3) {
        this.errors.sender_name = 'Name is too short'
        return true
      }
      if (this.contact.sender_email.length < 10) {
        this.errors.sender_email = 'Please entered a valid email'
        return true
      }
      if (this.contact.sender_message.length < 5) {
        this.errors.sender_message = 'Message is too short'
        return true
      }
      const mailFormat = /^[a-zA-Z0-9]+[.-_]?[a-zA-Z0-9]*@[a-zA-Z-]+(.[a-zA-Z0-9]{2,4})/
      if (!this.contact.sender_email.match(mailFormat)) {
        this.errors.sender_email = 'The email entered is invalid.'
        return
      }
      this.sendMailLoading = true
      emailJs.send('service_gblend-tech', 'template_gblend-tech', {
        to_name: 'Gabriel',
        website_url: location.host,
        sender_name: this.contact.sender_name,
        sender_email: this.contact.sender_email,
        sender_message: this.contact.sender_message
      }, 'user_5p9v05kB454yOL37NR33D')
        .then((result) => {
          this.sendMailLoading = false
          this.contact.sender_name = this.contact.sender_email = this.contact.sender_message = ''
          if (result.status === 200 && result.text === 'OK') {
            this.response.success = 'Email received! I will get in touch with you as soon as possible.'
            setTimeout(() => {
              this.response.success = ''
            }, 7000)
          }
        }, () => {
          this.sendMailLoading = false
          this.response.error = 'Oops! email was not sent. Please try again later.'
          setTimeout(() => {
            this.response.error = ''
          }, 7000)
        })
    },
    resetErrors () {
      this.errors.sender_name = this.errors.sender_email = this.errors.sender_message = ''
    }
  },
  computed: {
    sender_name_invalid () {
      return this.contact.sender_name.length < 3
    },
    sender_email_invalid () {
      return this.contact.sender_email.length < 10
    },
    sender_message_invalid () {
      return this.contact.sender_message.length < 5
    }
  },
  created () {
    this.resetErrors()
  }
}
</script>
